const environments = {
  stg: {
    httpLink: 'https://stg.daleapps.com/api/graphql',
  },
  dev: {
    httpLink: 'https://dev.daleapps.com/api/graphql',
  },
  prod: {
    httpLink: 'https://prod.daleapps.com/api/graphql',
  },
};

const environment = 'prod';

const selectedEnvironmentKey = environment.replace('{{', '').replace('}}', '');

export const selectedEnvironment =
  environments[selectedEnvironmentKey as keyof typeof environments];
